import axios from "axios";

export async function getApplicationVersion() {
  return await axios.get("/version");
}
